export default __webpack_public_path__ + "static/media/1 BHK S (WS).2a2b4d9a.png";